import * as types from '../ActionTypes/MembersActionTypes';
import { MemberModel } from '../../BusinessLogic/Models/MemberModel';
import {
    getClassModelsArray,
    getWaitingMemberModelsArray,
    getUserBirthdayModelsArray,
    getMemberModelsArray,
} from './helpers';

const initialState = {
    statuses: {
        classesForPlansLoading: false,
        birthdaysLoading: false,
        areMembersLoading: false,
        isPlanAddingToMember: false,
        waitingMembersLoading: false,
        isMemberAdding: {
            isAdding: false,
            addingId: null,
        },
        isMemberRemoving: {
            isRemoving: false,
            removingId: null,
        },
        isMemberUpdating: false,
    },
    members: [],
    waitingMembers: [],
    birthdays: [],
    classesForPlans: [],
};

export function MembersReducer(state = initialState, { type, payload, meta, ...actions }) {
    switch (type) {
        case types.GET_MEMBERS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    areMembersLoading: true,
                },
            };
        }

        case types.GET_MEMBERS_SUCCESS: {
            const membersArray = getMemberModelsArray(payload);

            return {
                ...state,
                members: [...membersArray],
                statuses: {
                    ...state.statuses,
                    areMembersLoading: false,
                },
            };
        }

        case types.ADD_MEMBER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMemberAdding: {
                        ...state.statuses.isMemberAdding,
                        isAdding: true,
                        addingId: meta.userData.user_id,
                    },
                },
            };
        }

        case types.ADD_MEMBER_SUCCESS: {
            const memberModel = new MemberModel(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMemberAdding: {
                        ...state.statuses.isMemberAdding,
                        isAdding: false,
                        addingId: '',
                    },
                },
                members: [...state.members, { ...memberModel.member }],
            };
        }

        case types.UPDATE_MEMBER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuse,
                    isMemberUpdating: true,
                },
            };
        }

        case types.UPDATE_MEMBER_SUCCESS: {
            const updateIndex = state.members.findIndex(member => member.id === payload.id);
            const newMembersList = JSON.parse(JSON.stringify(state.members));

            const memberModel = new MemberModel(payload);
            newMembersList[updateIndex] = { ...memberModel.member };

            return {
                ...state,
                members: [...newMembersList],
                statuses: {
                    ...state.statuses,
                    isMemberUpdating: false,
                },
            };
        }

        case types.DELETE_MEBMER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMemberRemoving: {
                        ...state.statuses.isMemberRemoving,
                        isRemoving: true,
                        removingId: meta.memberId,
                    },
                },
            };
        }

        case types.DELETE_MEMBER_SUCCESS: {
            const newMembersList = state.members.filter(member => member.id !== meta.memberId);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isMemberRemoving: {
                        ...state.statuses.isMemberRemoving,
                        isRemoving: false,
                        removingId: '',
                    },
                },
                members: [...newMembersList],
            };
        }

        case types.ADD_PLANS_TO_MEMBER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isPlanAddingToMember: true,
                },
            };
        }

        case types.ADD_PLANS_TO_MEMBER_SUCCESS: {
            const updateIndex = state.members.findIndex(member => member.id === payload.id);
            const newMembersList = JSON.parse(JSON.stringify(state.members));

            const memberModel = new MemberModel(payload);
            newMembersList[updateIndex] = { ...memberModel.member };

            return {
                ...state,
                members: [...newMembersList],
                statuses: {
                    ...state.statuses,
                    isPlanAddingToMember: false,
                },
            };
        }

        case types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    birthdaysLoading: true,
                },
            };
        }

        case types.GET_MEMBERS_BIRTHDAYS_BY_DATE_RANGE_SUCCESS: {
            const birthdaysArray = getUserBirthdayModelsArray(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    birthdaysLoading: false,
                },
                birthdays: [...birthdaysArray],
            };
        }

        case types.GET_WAITING_MEMBERS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    waitingMembersLoading: true,
                },
            };
        }

        case types.GET_WAITING_MEMBERS_SUCCESS: {
            const waitingMembersArray = getWaitingMemberModelsArray(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    waitingMembersLoading: false,
                },
                waitingMembers: [...waitingMembersArray],
            };
        }

        // TODO: to another reducer
        case types.GET_CLASSES_FOR_PLANS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    classesForPlansLoading: true,
                },
            };
        }

        case types.GET_CLASSES_FOR_PLANS_SUCCESS: {
            const classesArray = getClassModelsArray(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    classesForPlansLoading: false,
                },
                classesForPlans: [...classesArray],
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/MembersReducer.js